export default __webpack_public_path__ + "7bc739dd64edaaf8be9c5b403d85788f.mp3";